export const ALERT_DIALOG_TAG_NAME = "alert-dialog" as const;
